import BaseSwal from 'sweetalert2';
import colors from '../theme/colors';

const Swal = BaseSwal.mixin({
  confirmButtonColor: colors.geraldine,
});

export default Swal;
